import React from 'react';
import PropTypes from 'prop-types';
import ActiveBanner from './ActiveBanner';
import { useConnect } from '../../../../hooks/@lore/query-connect';
import useMissingFields from '@/pages/event-manage/useMissingFields';
import DraftBanner from './DraftBanner';
import CompletedBanner from './CompletedBanner';
import CancelledBanner from './CancelledBanner';
import ExpiredBanner from './ExpiredBanner';
import { isExpired } from '@/utils/dateTimeUtils';

Banner.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number.isRequired,
    data: PropTypes.shape({
      creatorId: PropTypes.number,
      completed: PropTypes.bool,
      cancelled: PropTypes.bool,
      published: PropTypes.bool,
      endDate: PropTypes.string
    }).isRequired
  }).isRequired
};

export default function Banner(props) {
  const { event } = props;

  const { missingFields } = useMissingFields(event);

  const creator = useConnect('user.byId', {
    id: event.data.creatorId
  });

  // return (
  //   <>
  //     <ActiveBanner
  //       event={event}
  //       creator={creator}
  //     />
  //     <DraftBanner
  //       event={event}
  //       creator={creator}
  //     />
  //     <CompletedBanner
  //       event={event}
  //       creator={creator}
  //     />
  //     <CancelledBanner
  //       event={event}
  //       creator={creator}
  //     />
  //     <ExpiredBanner
  //       event={event}
  //       creator={creator}
  //     />
  //   </>
  // );

  if (event.data.completed) {
    return (
      <CompletedBanner
        event={event}
        creator={creator}
      />
    );
  }

  if (event.data.cancelled) {
    return (
      <CancelledBanner
        event={event}
        creator={creator}
      />
    );
  }

  if (missingFields.data.length > 0) {
    return (
      <DraftBanner
        event={event}
        creator={creator}
      />
    );
  }

  if (isExpired(event.data.endDate)) {
    return (
      <ExpiredBanner
        event={event}
        creator={creator}
      />
    );
  }

  return (
    <ActiveBanner
      event={event}
      creator={creator}
    />
  );
};
